module.exports = __webpack_public_path__ + "img/CS-ProfiNew_Overview-Ad-U_1.5334e106.jpg";